var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',_vm._l((_vm.value),function(item){return _c('v-treeview-item',{key:item.id,staticClass:"v-treeview-item",attrs:{"model":item,"treeTypes":_vm.treeTypes,"openAll":_vm.openAll},on:{"selected":_vm.selected}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }